import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { store, actions } from '../../store';
import { Config, User, Player, PlayerSettings, useOktaQuery } from '../../data';
import usePlayerSelector from '../../utils/usePlayerSelector';

const RequireCurrentUserStore = ({ UserLoadingCallback, children }) => {
    const { state: { user: loggedInUser, config }, dispatch } = useContext(store);
    const { PlayerID: appPlayerId, IsMlb, IsPitcher } = usePlayerSelector();

    const userPlayerId = loggedInUser?.IsPlayer && loggedInUser.PlayerID;
    const { isFetching: currentUserLoading } = useOktaQuery('current-user', (t) => User.get(t), {
        onSuccess: (currentUser) => dispatch({ type: actions.LOG_IN, data: currentUser }),
    });
    useOktaQuery(['player', userPlayerId], (t) => Player.get(t, { playerId: userPlayerId }), {
        enabled: !!userPlayerId,
        onSuccess: (currentUserPlayer) => dispatch({ type: actions.ASSIGN_USER_PLAYER, data: currentUserPlayer }),
    });
    useOktaQuery(['player-team', userPlayerId], (t) => Player.orgrosterteam(t, userPlayerId), {
        enabled: !!userPlayerId,
        onSuccess: (playerTeam) => dispatch({ type: actions.SET_TEAM, data: playerTeam }),
    });
    useOktaQuery(['config'], (t) => Config.get(t), {
        enabled: !config,
        onSuccess: (configResp) => dispatch({ type: actions.SET_CONFIG, data: configResp }),
    });
    useOktaQuery(['player-rmb', appPlayerId], (t) => Player.getRmb(t, { playerId: appPlayerId }), {
        enabled: !!appPlayerId,
        onSuccess: (rmbResp) => dispatch({ type: actions.SET_PLAYER_RMB, data: rmbResp }),
    });
    useOktaQuery(['player-settings', appPlayerId, IsMlb, IsPitcher], (t) => PlayerSettings.get(t, appPlayerId, IsMlb, IsPitcher), {
        enabled: !!appPlayerId && !window.$IsDugoutApp,
        onSuccess: (playerSettingsResp) => dispatch({ type: actions.SET_PLAYER_SETTINGS, data: playerSettingsResp }),
    });

    useEffect(() => {
        UserLoadingCallback(currentUserLoading);
    }, [UserLoadingCallback, currentUserLoading]);

    if (!appPlayerId) return (loggedInUser?.UserName && !userPlayerId) ? (<Redirect to="/login/select-user" />) : null;
    if (!config) return null;
    return children;
};

RequireCurrentUserStore.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    UserLoadingCallback: PropTypes.any.isRequired,
    children: PropTypes.node.isRequired,
};

export default RequireCurrentUserStore;
